import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { ChartComponent } from "ng-apexcharts";
import _ from 'lodash';

import {
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexChart
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
};

@Component({
  selector: "pie-chart",
  templateUrl: "./pie-chart.component.html",
  styleUrls: ["./pie-chart.component.scss"]
})
export class PieChartComponent implements OnInit {
  @ViewChild("chart") chart: ChartComponent;
  @Input() seriesInput:any;
  @Input() labelsInput:any;
  @Input() colors:any;
  @Input() idPie:any;
  @Input() pieChartTitle:any;
  @Input() customDatasets:any;
  @Input() pieChartConfig: any;
  @Input() percentageArray: any;
  @Input() fullscreen:boolean;

  currentChart: any = null;

  public chartSeries: ApexNonAxisChartSeries;
  public chartOptions: Partial<ChartOptions>;
  private originalSeries: number[];

  idxSeriesRemoved: number[] = [];
  idxLabelsRemoved: number[] = [];
  
  dataLabels = {
    enabled: true,
    // background: {
    //   enabled: true, // Enable a background for data labels
    //   foreColor: '#ffffff ', // Set the background color of the data labels
    // },
    formatter(val, opts) {
      var value = Math.round(opts.w.globals.series[opts.seriesIndex]);
      var finalValue;
      if (value % 1 === 0) {
        finalValue = value;
      } else {
        finalValue = value.toFixed(2);
      }
      // return `${opts.w.globals.series[opts.seriesIndex]}: ${val}%`;
      return `${(val).toFixed()}% (${finalValue})`;
    },
    style: {
      colors: ['#495057'], 
    },
    dropShadow: {
      enabled: false
    }
  };

  htmlelent: HTMLElement; 

  tooltips = {};

  legend: {
    // show: true,
    // position: 'bottom',
  }

  listColors = [];

  ngOnInit(): void {}
  
  ngOnChanges(): void {

    this.idxSeriesRemoved = [];
    this.idxLabelsRemoved = [];
    this.listColors = this.colors;
    const title = this.pieChartTitle;
    

    if (this.fullscreen === false) {

      if (
        this.idPie ==='engineer-utilization' || 
        this.idPie ==='engineer-utilization-c-opc' ||
        this.idPie ==='engineer-utilization-func-opc'
      ) {
        this.tooltips = {
          enabled: true,
          style: {
            padding: '5px' 
          },
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            let listData:any = [];
            const percentagesList = convertToPercentages(series);
            w.config.labels.forEach(function (value, index) {
              listData.push(value + ': ' + parseFloat(series[index]).toFixed(2) + '(' + round(percentagesList[index]) + '%)');
            }); 
            return (
              '<div style="padding: 10px;">' +
              '<b>' +
              title +
              '</b>' +
              '<br/>' +
              listToHTML(listData) + 
              '<br/>' +
              '<br/>' +
              'Total %: 100%' 
            );
          },
        };
      } else {
        this.tooltips = {
          enabled: true,
          style: {
            padding: '5px' 
          },
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            let listData:any = [];
            const percentagesList = convertToPercentages(series);
            w.config.labels.forEach(function (value, index) {
              listData.push(value + ': ' + series[index] + '(' + round(percentagesList[index]) + '%)');
            }); 
            return (
              '<div style="padding: 10px;">' +
              '<b>' +
              title +
              '</b>' +
              '<br/>' +
              listToHTML(listData) + 
              '<br/>' +
              '<br/>' +
              'Total %: 100%' 
            );
          },
        };
      }

      this.chartOptions = {
        series: this.seriesInput,
        chart: {
          width: (
            this.idPie ==='engineer-utilization' || 
            this.idPie ==='engineer-utilization-c-opc' ||
            this.idPie ==='engineer-utilization-func-opc'
          ) ? 280 : 380,
          type: "pie",
          fontFamily: "Nunito Sans, sans-serif",
        },
        labels: this.labelsInput,
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 300,
                fontFamily: "Nunito Sans, sans-serif"
              },
              legend: {
                show: true, 
                position: 'right', 
              },
            }
          }
        ]
      };
    } else {

      if (
        this.idPie ==='engineer-utilization' || 
        this.idPie ==='engineer-utilization-c-opc' ||
        this.idPie ==='engineer-utilization-func-opc'
      ) {
        this.tooltips = {
          enabled: true,
          style: {
            padding: '5px' 
          },
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            let listData:any = [];
            const percentagesList = convertToPercentages(series);
            w.config.labels.forEach(function (value, index) {
              listData.push(value + ': ' + parseFloat(series[index]).toFixed(2) + '(' + round(percentagesList[index]) + '%)');
            }); 
            
            return (
              '<div style="padding: 10px;">' +
              '<div style="position: relative; top: 30%; height: auto;">' +
              '<b>' +
              title +
              '</b>' +
              '<br/>' +
              listToHTML(listData) + 
              '<br/>' +
              '<br/>' +
              'Total %: 100%' +
              '</div>'
            );
          },
        };
      } else {
        this.tooltips = {
          enabled: true,
          style: {
            padding: '5px' 
          },
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            let listData:any = [];
            const percentagesList = convertToPercentages(series);
            w.config.labels.forEach(function (value, index) {
              listData.push(value + ': ' + series[index] + '(' + round(percentagesList[index]) + '%)');
            }); 
            
            return (
              '<div style="padding: 10px;">' +
              '<div style="position: relative; top: 30%; height: auto;">' +
              '<b>' +
              title +
              '</b>' +
              '<br/>' +
              listToHTML(listData) + 
              '<br/>' +
              '<br/>' +
              'Total %: 100%' +
              '</div>'
            );
          },
        };
      }
      
      this.chartOptions = {
        series: this.seriesInput,
        chart: {
          width: (
            this.idPie ==='engineer-utilization' || 
            this.idPie ==='engineer-utilization-c-opc' ||
            this.idPie ==='engineer-utilization-func-opc'
          ) ? 450 : 750,
          type: "pie",
          fontFamily: "Nunito Sans, sans-serif"
        },
        labels: this.labelsInput,
      };
    }
    
  }

  customToggleLegend(index) {

		this.customDatasets[index].disabled = ! this.customDatasets[index].disabled;

    if (this.customDatasets[index].disabled) {
      this.idxSeriesRemoved.push(index);
      this.idxLabelsRemoved.push(index);
    } else {
      const indexSeriesToRemove: number = this.idxSeriesRemoved.indexOf(index); 
      const indexLabelsToRemove: number = this.idxLabelsRemoved.indexOf(index); 

      if (indexSeriesToRemove !== -1) {
        this.idxSeriesRemoved.splice(indexSeriesToRemove, 1);
      }
      if (indexLabelsToRemove !== -1) {
        this.idxLabelsRemoved.splice(indexLabelsToRemove, 1);
      }

    }

    const newSeries: number[] = this.seriesInput.map((value, index) => {
      if (this.idxLabelsRemoved.includes(index)) {
        return 0;
      }
      return value;
    });

    this.chartOptions = {
      series: newSeries,
      chart: {
        type: "pie",
        fontFamily: "Nunito Sans, sans-serif",
        width: (
          this.idPie ==='engineer-utilization' || 
          this.idPie ==='engineer-utilization-c-opc' ||
          this.idPie ==='engineer-utilization-func-opc'
        ) ? (this.fullscreen ? 750 : 280) : (this.fullscreen ? 750 : 380),
      },
      labels: this.labelsInput,
      responsive: [
        {
          options: {
            legend: {
              show: true, 
              position: 'right',
            },
            
          }
        }
      ]
    };
	}

}


function round (value: number) {
  return (Math.round(100 * value) / 100).toFixed();
}

function listToHTML(items: string[]): string {
  const htmlString = items.join('<br>');
  return htmlString;
}

function convertToPercentages(data: number[]): number[] {
  const total = data.reduce((acc, val) => acc + val, 0);
  const percentages = data.map((value) => (value / total) * 100);
  return percentages;
}
